import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from 'app/common/toast-alert/toast.service';
import { POItemUnitEnum } from '../../globals-enums/po.unit.enum';
import { PurchaseOrderService } from '../../globals-services/purchase-order.service';

@Component({
    selector: 'app-add-purchase-order',
    templateUrl: './add-purchase-order.component.html',
    styleUrls: ['./add-purchase-order.component.css'],
})
export class AddPurchaseOrderComponent implements OnInit {
    orderForm: FormGroup;

    isUpdate: boolean = false;
    selectedManufacturer: any;
    pOUnitEnum = POItemUnitEnum;

    formulaList: any = [];
    localFormulaList: any = [];
    manufacturerList: any = [];
    poId: any;
    poDetails: any;
    //showSuccessMessage: boolean = false;
    // showErrorMessage: boolean = false;
    isLoading: boolean;
    supplierList: any = [];
    //showPoUpdateSuccessMessage: boolean = false;
    // showPoItemDeletedMessage: boolean = false

    localManufacturerList: any = [];
    localSupplierList: any = [];
    alertMsgs = {};

    constructor(
        private fb: FormBuilder,
        private purchaseOrderService: PurchaseOrderService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private translateService: TranslateService,
        private toastService: ToastService
    ) {}

    ngOnInit() {
        this.fetchTranslations();
        this.translateService.onLangChange.subscribe(() => {
            this.fetchTranslations();
        });

        this.activatedRoute.params.subscribe((params) => {
            this.poId = params['id'];

            if (this.poId != null) {
                this.isUpdate = true;
                this.getPoDetails();
            }
        });
        this.initPOForm();
        this.getUniqueNumber();
    }

    fetchTranslations() {
        this.translateService
            .get('PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.SHOW_MESSAGES')
            .subscribe((response) => {
                this.alertMsgs = response;
                // console.log(this.alertMsgs);
            });
    }

    getPoDetails() {
        let data = {
            id: this.poId,
        };

        this.purchaseOrderService.getPoDetails(data).subscribe(
            (response: any) => {
                this.poDetails = response;
                this.orderForm.patchValue(this.poDetails);
                this.orderForm.patchValue({
                    poDate: new Date(this.poDetails.poDate),
                });
                const ctrl = this.orderForm.get('poItems') as FormArray;
                this.deleteItem(0);

                this.poDetails.poItems.forEach((item) => {
                    ctrl.push(this.initItemForm());
                });
                ctrl.patchValue(this.poDetails.poItems);
                this.selectedManufacturer = response.manufacturerName;
            },
            (error) => {
                // if (error['status'] == '404' || error['status'] == '500' || error['status'] == '401') {
                //   alert("The action could not be completed. Please try again later.If the problem persists please contact Bhive team.")
                // }
            }
        );
    }

    initPOForm() {
        this.orderForm = this.fb.group({
            id: ['', Validators.nullValidator],
            poNumber: ['', Validators.required],
            poDate: ['', Validators.required],
            manufacturerName: ['', Validators.required],
            supplierName: ['', Validators.nullValidator],
            referenceNumber: ['', Validators.required],
            approvedBy: ['', Validators.nullValidator],
            poItems: this.fb.array([this.initItemForm()]),
        });
    }
    get getPoItemControl() {
        return this.orderForm.get('poItems') as FormArray;
    }

    initItemForm() {
        return this.fb.group({
            id: ['', Validators.nullValidator],
            purchaseOrderChemicalId: ['', Validators.nullValidator],
            formulaName: ['', Validators.nullValidator],
            elxsData: ['', Validators.nullValidator],
            quantity: ['', Validators.required],

            approved: ['', Validators.nullValidator],
            zdhcMrsl: ['', Validators.nullValidator],

            unit: ['', Validators.required],
        });
    }

    addItem() {
        const ctrl = this.orderForm.get('poItems') as FormArray;
        ctrl.push(this.initItemForm());
    }

    deleteItem(index) {
        const ctrl = this.orderForm.get('poItems') as FormArray;
        ctrl.removeAt(index);
    }

    savePo(formValue) {
        // const converted = new Date(formValue.poDate).toLocaleDateString();
        // // console.log(converted); // 8/6/2019 (MM/DD/YYYY) format
        // formValue.poDate = converted
        this.isLoading = true;
        this.purchaseOrderService.createPurchaseOrder(formValue).subscribe(
            (response) => {
                this.toastService.success(this.alertMsgs['PO_SAVE'], true);
                this.isLoading = false;
                this.router.navigateByUrl('/purchase-order');

                // this.showSuccessMessage = true;

                // setTimeout(() => {
                //     this.showSuccessMessage = false;

                //     this.isLoading = false;
                //     this.router.navigateByUrl('/purchase-order');
                // }, 2000);
            },
            (error) => {
                // if (error['status'] == '404' || error['status'] == '500' || error['status'] == '401') {
                //   alert("The action could not be completed. Please try again later.If the problem persists please contact Bhive team.")

                // }
                // else
                this.isLoading = false;
                if (error['status'] == '409') {
                    this.toastService.error(this.alertMsgs['PO_SAVE_ERROR']);
                    // this.showErrorMessage = true
                }
                // setTimeout(
                //   () => {
                //     this.isLoading = false;
                //     this.showErrorMessage = false
                //   }, 3000
                // );
            }
        );
    }

    onFormulaSearch(event) {
        let searchValue = event.target.value;

        if (searchValue.length == 0) {
            this.formulaList = [];
            this.localFormulaList = [];
        }

        if (this.selectedManufacturer != null && searchValue.length > 0) {
            this.searchFormula(event);
        }
    }

    searchFormula(event) {
        let formulaInputText = event.target.value;

        if (formulaInputText.length == 0) {
            this.localFormulaList = [];
            this.formulaList = [];
        }

        if (this.localFormulaList.length != 0) {
            this.localFormulaList = this.formulaList.filter((res) => {
                return res.name
                    .toLowerCase()
                    .match(formulaInputText.toLocaleLowerCase());
            });

            this.formulaList = this.localFormulaList;
        }

        if (this.localFormulaList.length === 0 || event.keyCode == 8) {
            let data = {
                searchText: formulaInputText,
                manufacturer: this.selectedManufacturer,
            };

            if (formulaInputText.length != 0) {
                this.purchaseOrderService.searchFormula(data).subscribe(
                    (response) => {
                        if (response) {
                            this.formulaList = response;
                            //    this.localManufacturerList = response;
                            this.localFormulaList = response;
                        }
                    },
                    (error) => {
                        // if (error['status'] == '404' || error['status'] == '500' || error['status'] == '401') {
                        //   alert("The action could not be completed. Please try again later.If the problem persists please contact Bhive team.")
                        // }
                    }
                );
            }
        }
    }
    onManufacturerSelect(manufacturer) {
        this.selectedManufacturer = manufacturer;
        this.formulaList = [];
        this.localFormulaList = [];
    }

    onManufacturerSearch(event) {
        //  console.log(event)

        this.formulaList = [];
        this.localFormulaList = [];

        let inputText = event.target.value;

        if (inputText.length == 0) {
            this.localManufacturerList = [];
            this.manufacturerList = [];
        }

        if (this.localManufacturerList.length != 0) {
            this.localManufacturerList = this.manufacturerList.filter((res) => {
                return res.toLowerCase().match(inputText.toLocaleLowerCase());
            });

            //  console.log(this.localManufacturerList)

            this.manufacturerList = this.localManufacturerList;

            //  console.info(this.manufacturerList)
        }

        if (this.localManufacturerList.length === 0 || event.keyCode == 8) {
            let data = {
                searchText: inputText,
            };

            if (inputText.length != 0) {
                this.purchaseOrderService.searchManufacturer(data).subscribe(
                    (response) => {
                        if (response) {
                            this.manufacturerList = response;
                            this.localManufacturerList = response;
                        }
                    },

                    (error) => {
                        // if (error['status'] == '404' || error['status'] == '500' || error['status'] == '401') {
                        //   alert("The action could not be completed. Please try again later.If the problem persists please contact Bhive team.")
                        // }
                    }
                );
            }
        }
    }
    onSupplierSearch(event) {
        let inputText = event.target.value;

        if (inputText.length == 0) {
            this.localSupplierList = [];
            this.supplierList = [];
        }

        if (this.localSupplierList.length != 0) {
            this.localSupplierList = this.supplierList.filter((res) => {
                return res.toLowerCase().match(inputText.toLocaleLowerCase());
            });

            this.supplierList = this.localSupplierList;
        }

        if (this.localSupplierList.length === 0 || event.keyCode == 8) {
            let data = {
                searchText: inputText,
            };

            if (inputText.length != 0) {
                this.purchaseOrderService.searchManufacturer(data).subscribe(
                    (response) => {
                        if (response) {
                            this.supplierList = response;
                            this.localSupplierList = response;
                        }
                    },
                    (error) => {
                        // if (error['status'] == '404' || error['status'] == '500' || error['status'] == '401') {
                        //   alert("The action could not be completed. Please try again later.If the problem persists please contact Bhive team.")
                        // }
                    }
                );
            }
        }
    }

    updatePo(po) {
        // const converted = new Date(po.poDate).toLocaleDateString();
        // // console.log(converted); // 8/6/2019 (MM/DD/YYYY) format
        // po.poDate = converted;
        this.isLoading = true;
        this.purchaseOrderService.updatePurchaseOrder(po).subscribe(
            (response: any) => {
                this.toastService.success(this.alertMsgs['PO_UPDATE'], true);
                this.isLoading = false;
                this.router.navigateByUrl('/purchase-order');

                // this.showPoUpdateSuccessMessage = true;

                // setTimeout(() => {
                //     this.showPoUpdateSuccessMessage = false;

                //     this.isLoading = false;
                //     this.router.navigateByUrl('/purchase-order');
                // }, 3000);
            },

            (error) => {
                // if (error['status'] == '404' || error['status'] == '500' || error['status'] == '401') {
                //   alert("The action could not be completed. Please try again later.If the problem persists please contact Bhive team.")

                // }
                // else
                if (error['status'] == '409') {
                    //  this.showErrorMessage = true
                    this.toastService.error(this.alertMsgs['PO_SAVE_ERROR']);
                }
                setTimeout(() => {
                    this.isLoading = false;
                }, 5000);
            }
        );
    }

    deletePOItem(i, poItem) {
        this.purchaseOrderService.deletePOItem(poItem.value).subscribe(
            (response: any) => {
                this.toastService.success(this.alertMsgs['PO_ITEM_DELETE']);
                this.deleteItem(i);

                // this.showPoItemDeletedMessage = true;
                // this.deleteItem(i);
                // setTimeout(
                //   () => {
                //     this.showPoItemDeletedMessage = false;

                //   }, 3000
                // );
            },
            (error) => {
                // if (error['status'] == '404' || error['status'] == '500' || error['status'] == '401') {
                //   alert("The action could not be completed. Please try again later.If the problem persists please contact Bhive team.")
                // }
            }
        );
    }

    onFormulaSelect(formula, poItem) {
        // console.info(formula)
        if (formula != null) {
            poItem.patchValue({
                zdhcMrsl: formula.zdhcMrsl,
                // quantity: '',
                // unit: ''
            });
        } else {
            poItem.patchValue({
                zdhcMrsl: '',
            });
        }
    }
    onNonDbFormulaAdded(ev, poItem) {
        // console.info(ev)
        poItem.patchValue({
            zdhcMrsl: '',
        });
    }

    getUniqueNumber() {
        let dateObj = new Date();
        let month = dateObj.getUTCMonth() + 1; //months from 1-12
        let day = dateObj.getUTCDate();
        let year = dateObj.getUTCFullYear();
        let hour = dateObj.getHours();
        let min = dateObj.getMinutes();
        let sec = dateObj.getSeconds();

        this.orderForm.patchValue({
            poNumber: 'PO-' + year + '/' + month + '/' + day + '/' + hour + min,
        });
    }
}
